import React from 'react';
import ReactDOM from 'react-dom';
import '@ifeng-fe/container_channel/common/client/commoncss/resetMobile.css';
import Grounds from 'ThreeTerminal_base/grounds';
import Layout from './layout';

Grounds.setShareVisibility(false);

/* eslint-disable */
allData.reportType = allData.params.reportType;
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
